module.exports = __webpack_public_path__ + "static/media/sub_background.3afd182b.png";